import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import { scenarioEngine } from './scenario/engine';
import { registerWebMcpTools } from './webmcp/register';

const webMcpRegistration = registerWebMcpTools(scenarioEngine);

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    void webMcpRegistration.then((controller) => controller?.abort());
  });
}

window.addEventListener('beforeunload', () => {
  void webMcpRegistration.then((controller) => controller?.abort());
}, { once: true });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
